<template >
  <div>
    <b-dropdown offset="200" right>
      <template slot="button-content">
        {{dateRangeText}}
      </template>
      <div class='dropdown-content'>
        <datepicker :highlighted="highlighted" class="datepicker1" :inline="true" v-model="startDate">
        </datepicker>
        <datepicker :highlighted="highlighted" class="datepicker2" :inline="true" v-model="endDate">
        </datepicker>
       </div>
    </b-dropdown>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {mapGetters} from 'vuex'
export default {
  name: 'DateRangeSelector',
  components: {
    Datepicker
  },
  props: ['defautlStart', 'defautlEnd'],
  data () {
    return {
      startDate: '',
      endDate: ''
    }
  },
  created () {
    this.startDate = this.defautlStart ? this.defautlStart : moment().startOf('month')
    this.endDate = this.defautlEnd ? this.defautlEnd : moment().endOf('month').format('MM/DD/YYYY')
  },
  computed: {
    ...mapGetters(['reportDates', 'currentReportMailbox']),
    dateRangeText: function () {
      return `${moment(this.startDate).format('MM/DD/YYYY')} - ${moment(this.endDate).format('MM/DD/YYYY')}`
    },
    highlighted: function () {
      return {to: moment(this.endDate, 'MM/DD/YYYY'), from: moment(this.startDate, 'MM/DD/YYYY')}
    }
  },
  methods: {
  },
  watch: {
    startDate () {
      this.startDate = moment(this.startDate).format('MM/DD/YYYY')
      this.$emit('selected', {startDate: this.startDate, endDate: this.endDate})
    },
    endDate () {
      this.endDate = moment(this.endDate).format('MM/DD/YYYY')
      this.$emit('selected', {startDate: this.startDate, endDate: this.endDate})
    }
  }
}
</script>

<style scoped>
@media (min-width: 1025px) {
  >>> .dropdown-menu{
    width: 620px
  }
  >>> .vdp-datepicker__calendar{
    border: 0px
  }
  .dropdown-content {
    width: 600px
  }
  .datepicker1{
    float: left;
  }
  .datepicker2{
    float: right;
  }
}
@media (max-width: 480px) {
}
</style>



// WEBPACK FOOTER //
// src/components/selectors/DateRangeSelector.vue